<div class="container">
  <app-header class="header" [title]="'PAGES.PROGRAM_GUIDE.TITLE' | translate"></app-header>
  <div class="content">
    <app-ipg class="content__ipg"></app-ipg>
  </div>
</div>
